import React from 'react';
import { Typography } from '@mui/material';

interface SectionTitleProps {
  title: string;
}

export const SectionTitle = ({ title }: SectionTitleProps) => {
  return (
    <Typography
      sx={{
        marginTop: 6,
        marginBottom: 4,
        fontWeight: 600,
        fontSize: 18,
      }}
    >
      {title}
    </Typography>
  );
};
